import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

export default {
  title: "Servizi strutture",
  resource: "facility-services",
  canCreate: true,
  //metas: { populate: ["facility_service_type"] },
  columns: [
    { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      field: "facility_service_type",
      headerName: "Tipologia",
      valueGetter: ({ row }) => {
        const value = row.facility_service_type?.name;
        return value;
      },
      flex: 1,
      minWidth: 300,
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 50,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
